import { Grid } from '@mui/material';
import { GVTypography } from 'components/lib';
import { DifferenceProps } from '../DifferenceElementView';

const AnnotationDifference = ({ classes: parentClasses }: DifferenceProps) => {
  return (
    <Grid container direction="column" className={parentClasses.classes.textContainer}>
      <GVTypography className={parentClasses.classes.text}>Select this card to view the annotation</GVTypography>
    </Grid>
  );
};

export default AnnotationDifference;
